import { Column, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn } from 'typeorm';
import { Entente } from './entente.entity';
import { Thematique } from './thematique.entity';
import ActiviteEntenteProduit from './activite-entente-produit.entity';
import { Activite } from './activite.entity';

@Entity('activite_entente')
export default class ActiviteEntente {
    static key = 'activite-entente';

    name = ''; // Pour le formulaire

    @PrimaryGeneratedColumn()
    id: number;

    @OneToMany(
        () => ActiviteEntenteProduit,
        (activiteEntenteProduit: ActiviteEntenteProduit) => activiteEntenteProduit.activiteEntente,
        { cascade: ['insert', 'update', 'remove'] },
    )
    activiteEntenteProduit: ActiviteEntenteProduit[];

    @Column()
    fk_id_entente: number;

    @ManyToOne(() => Entente, (entente) => entente.activiteEntentes)
    @JoinColumn({ name: 'fk_id_entente', referencedColumnName: 'id' })
    entente: Entente;

    @Column()
    fk_id_activite: number;

    @ManyToOne(() => Activite)
    @JoinColumn({ name: 'fk_id_activite', referencedColumnName: 'id' })
    activite: Activite;

    @Column({ nullable: true })
    fk_id_thematique: number;

    @ManyToOne(() => Thematique)
    @JoinColumn({ name: 'fk_id_thematique' })
    thematique: Thematique;

    @Column({ type: 'integer', nullable: true })
    priorite: number;

    @Column({ nullable: true })
    note_fournisseur_invisible: boolean;

    @Column({ nullable: true })
    note_client_invisible: boolean;

    @Column({ nullable: true })
    note_interne_invisible: boolean;

    @Column({ nullable: true })
    note_du_fournisseur_invisible: boolean;
}
